import { initAutocompleteDevices } from '../components/initAutocompleteDevices';

document.addEventListener('DOMContentLoaded', function () {
    initAutocompleteDevices();
});
